import { useContext, useEffect } from 'react';
import { AppContext } from '../components/AppContext';
import { Annotator } from '../annotations/annotator';

export function useAnnotator() {
    const { annotations, annotator, setters } = useContext(AppContext);

    useEffect(() => {
        if (annotator && annotator.updates) {
            for (const u of annotator.updates) {
                const updatedAnnotations = Annotator.updateState(u, annotations);

                if (setters && setters.setAnnotations) {
                    setters.setAnnotations(updatedAnnotations);
                }
            }

            annotator.updates.length = 0;
        }
    }, [annotator, annotations, setters]);

    return annotator;
}
